import {EmailAddressRestDto} from "@/api/pharma-cms-content-block/models";

export class EmailAddressRestDtoModel implements EmailAddressRestDto {
    email: string;
    name: string | null;


    constructor(email: string) {
        this.email = email;
        this.name = null;
    }

    public static createWithDefaults(): EmailAddressRestDtoModel {
        return new EmailAddressRestDtoModel(
            '',
        );
    }
}
